// =================================================
// library.js（IntersectionObserver対応・安全版）
// =================================================

$(function() {

	// main margin を header 高さに合わせる
	function setMainMargin() {
	  const header = document.querySelector('header');
	  const main   = document.querySelector('main');
	  if (!header || !main) return; // 要素が無ければ何もしない
	  const headerHeight = header.offsetHeight;
	  main.style.marginTop = headerHeight + 'px';
	}
	$(window).on('load resize', setMainMargin);
  
	// ---------------------------
	// アコーディオン
	// ---------------------------
	$('.js-toggle').on('click', function() {
	  $(this).toggleClass('is-active');
	  $(this).next('.js-toggle-target').stop().slideToggle(300);
	});
  
	// ---------------------------
	// アンカーリンク（スムーススクロール）
	// ---------------------------
	$('a[href^="#"]').not('.exc').on('click', function(e) {
	  e.preventDefault();
	  const speed = 400;
	  const href  = $(this).attr("href");
	  const $target = $(href === "#" || href === "" ? 'html' : href);
  
	  // 対象要素が存在しない場合は何もしない
	  if ($target.length === 0) return;
  
	  const position = $target.offset().top;
	  $('body,html').animate({ scrollTop: position }, speed, 'swing');
	});
  
	// ---------------------------
	// UA 判定（IE / Android）
	// ---------------------------
	const ua = navigator.userAgent || '';
  
	if (ua.toLowerCase().includes('msie') || ua.includes('Trident')) {
	  $("html").addClass("ie");
	}
	if (ua.includes('Android')) {
	  $("html").addClass("android");
	}
  
	// ---------------------------
	// viewport 設定
	// （すでに meta[name=viewport] がある場合は重複を避ける）
	// ---------------------------
	if ($('meta[name="viewport"]').length === 0) {
	  if (
		ua.indexOf('iPhone') > 0 ||
		ua.indexOf('iPod') > 0 ||
		(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
	  ) {
		$('head').prepend(
		  '<meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=no">'
		);
	  } else {
		$('head').prepend('<meta name="viewport" content="width=1280">');
	  }
	}
  
	// ---------------------------
	// SP スクロールボタン制御
	// ---------------------------
	if (/iPhone|iPod|Android.*Mobile/.test(ua)) {
	  $(".scroll").on('touchstart', function() {
		$(this).addClass("off");
	  });
	}
  
	// =================================================
	// フェードインアニメーション（IntersectionObserver化）
	// =================================================
	const fadeTargets = document.querySelectorAll(
	  '.fadein, .fadein_detail, .fadein_t, .fadein_b, .fadein_l, .fadein_r, .js-animation'
	);
  
	if (fadeTargets.length > 0) {
	  if ('IntersectionObserver' in window) {
		const fadeObserver = new IntersectionObserver((entries, observer) => {
		  entries.forEach(entry => {
			if (entry.isIntersecting) {
			  entry.target.classList.add('on');
			  observer.unobserve(entry.target); // 一度発火したら監視解除
			}
		  });
		}, {
		  rootMargin: '0px 0px -10% 0px', // 下方向に余裕
		  threshold: 0.2 // 20%見えたら発火
		});
  
		fadeTargets.forEach(el => fadeObserver.observe(el));
	  } else {
		// Fallback：古いブラウザ用（即時追加）
		fadeTargets.forEach(el => el.classList.add('on'));
	  }
	}
  
	// ---------------------------
	// ページ読み込み直後に発火する要素
	// ---------------------------
	setTimeout(() => {
	  document
		.querySelectorAll('.js-animation_on')
		.forEach(el => el.classList.add('on'));
	}, 200);
  });
  
  // =================================================
  // footer 行末線制御（安全版）
  // =================================================
  function hideLineAtRowEnd() {
	const items = document.querySelectorAll('.footer_list_item');
  
	// 対象要素が1つも無ければ何もしない（←ここが重要）
	if (!items || items.length === 0) {
	  return;
	}
  
	let lastTop = null;
  
	// いったんリセット
	items.forEach(item => item.classList.remove('is-row-end'));
  
	items.forEach((item, i) => {
	  if (!item || typeof item.getBoundingClientRect !== 'function') {
		return; // 念のためガード
	  }
	  const top = item.getBoundingClientRect().top;
  
	  if (lastTop !== null && top !== lastTop && i > 0) {
		// 行が変わった → 前の要素を「行末」とみなす
		const prev = items[i - 1];
		if (prev && prev.classList) {
		  prev.classList.add('is-row-end');
		}
	  }
	  lastTop = top;
	});
  
	// 最終行の最後も「行末」にする
	const lastItem = items[items.length - 1];
	if (lastItem && lastItem.classList) {
	  lastItem.classList.add('is-row-end');
	}
  }
  
  // resize / load 時のハンドラ登録
  window.addEventListener('resize', hideLineAtRowEnd);
  window.addEventListener('load', hideLineAtRowEnd);
  